import { createFileRoute, useSearch, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { DisposalForm } from "@/features/disposals/DisposalForm";
import { canCreateDisposal } from "@/lib/roles";
import { currentUserQueryOptions } from "@/hooks/useCurrentUser";

export const Route = createFileRoute("/_authenticated/disposals/new")({
  validateSearch: z.object({ assetId: z.string().optional() }),
  beforeLoad: async ({ context }) => {
    const me = await context.queryClient.ensureQueryData(currentUserQueryOptions());
    if (!canCreateDisposal(me.roles)) throw redirect({ to: "/disposals" });
  },
  component: NewDisposal,
});

function NewDisposal() {
  const search = useSearch({ from: "/_authenticated/disposals/new" });
  return <DisposalForm presetAssetId={search.assetId} />;
}
